import locationModuleState from "./location/state";

export default {
  ...locationModuleState,
};
